import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown,
  faChevronUp,
  faCircleArrowRight,
} from '@fortawesome/free-solid-svg-icons';

function NavMovil() {
  // Array de links
  const links = [
    { name: 'Inicio', path: '/' },
    { name: 'Productos', path: '/productos' },
    {
      name: 'Nosotros',
      sublinks: [
        { name: 'Quienes somos', path: '/nosotros' },
        { name: 'Contacto', path: '/contacto' },
      ],
    },
  ];

  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const ref = useRef(null);

  const handleClickOutside = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setOpenMenuIndex(null);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleMenu = (index) => {
    setOpenMenuIndex(openMenuIndex === index ? null : index);
  };
  return (
    <div ref={ref}>
      <ul className="flex flex-col font-semibold text-base px-1">
        {links.map((link, index) => (
          <li key={link.path} className="flex flex-col my-1">
            {link.sublinks ? (
              <>
                <button
                  className={`flex justify-between items-center rounded-lg py-2.5 px-3 uppercase text-sm font-extrabold tracking-wide transition-colors duration-150 ${
                    openMenuIndex === index
                      ? 'bg-[#0f274b] text-white'
                      : 'bg-gray-50 text-[#0f274b] hover:bg-[#0f274b]/10'
                  }`}
                  onClick={() => toggleMenu(index)}
                  type="button"
                >
                  {link.name}
                  <FontAwesomeIcon
                    icon={openMenuIndex === index ? faChevronUp : faChevronDown}
                    className={`text-sm ${openMenuIndex === index ? 'text-[#00BEE7]' : 'text-gray-400'}`}
                  />
                </button>
                {openMenuIndex === index && (
                  <ul className="flex flex-col mt-1 ml-3 border-l-2 border-[#00BEE7]/40">
                    {link.sublinks.map((sublink) => (
                      <li key={sublink.path} className="flex">
                        <Link
                          to={sublink.path}
                          className="flex w-full items-center gap-2 text-[#0f274b] hover:text-[#007fa0] py-2 pl-3 text-sm font-semibold transition-colors duration-150"
                        >
                          <FontAwesomeIcon
                            icon={faCircleArrowRight}
                            className="text-[#00BEE7] text-base shrink-0"
                          />
                          {sublink.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </>
            ) : (
              <Link
                to={link.path}
                className="flex justify-between items-center bg-gray-50 hover:bg-[#0f274b]/10 text-[#0f274b] hover:text-[#007fa0] rounded-lg py-2.5 px-3 uppercase text-sm font-extrabold tracking-wide transition-colors duration-150"
              >
                {link.name}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default NavMovil;
